module.exports = __webpack_public_path__ + "img/Task book Literacy.09c599f3.png";